import { render } from "./TableEditor.vue?vue&type=template&id=448cc797&scoped=true"
import script from "./TableEditor.vue?vue&type=script&lang=js"
export * from "./TableEditor.vue?vue&type=script&lang=js"

import "./TableEditor.vue?vue&type=style&index=0&id=448cc797&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448cc797"]])

export default __exports__